export default "__VITE_ASSET__BEJFPrPQ__"